export default __webpack_public_path__ + "static/media/truthsector.b9691c85.png";